module.exports = __webpack_public_path__ + "static/media/south.95dbef53.png";